import React from 'react';
import { PageSidebar as MssPageSidebar } from '@mss/mss-component-library';

const PageSidebar: typeof MssPageSidebar = ({ ...props }) => (
  <MssPageSidebar {...props} theming="site" />
);

export default PageSidebar;
